export const maskEmail = (email?: string): string => {
  if (email === undefined) {
    return ''
  }
  const length = email.length
  const first2 = email.substring(0, 2)
  const first3 = email.substring(0, 3)
  const last5 = email.substring(length - 5)
  const last3 = email.substring(length - 3)
  const last1 = email.substring(length - 1)
  const mask = '•••'
  return length > 9 ? first3 + mask + last5 : length > 7 ? first3 + mask + last3 : first2 + mask + last1
}
